import { NotificationsSettings as NotificationsBody } from '../../components/settings/notifications'
import { BackRow, Band, BandHeading, SCROLL_BOTTOM } from '../shell/parts'

// ============================================================================
// NOTIFICATIONS — the ONE settings screen the phone has, and the reason it has it.
//
// THE HANDOFF SAYS SETTINGS STAY ON DESKTOP (docs/design/handoff-mobile/README.md §Overview:
// "Journal index and day pages, Lecture study mode, Learning tracks, Interests library, Search,
// Connections/settings. Those stay on desktop."). That line is kept everywhere it can be: every
// other `/settings/*` route still lands on DesktopOnly, and this screen adds no second place to
// edit anything the desktop already edits.
//
// IT CANNOT BE KEPT HERE, because of a fact about Web Push rather than a preference about layout:
// a push subscription belongs to THE BROWSER IT WAS CREATED IN. The switch below calls
// `PushManager.subscribe()` on this device and registers this device's endpoint; pressing it on
// the desktop subscribes the desktop. So "notifications on the phone" is not a setting the desktop
// can turn on — and until this screen existed there was no way to turn it on at all. The mobile
// handoff was drawn before Web Push existed in this app at all, and a rule written about a screen
// that did not yet exist does not get to decide this one.
//
// IT IS THE SAME COMPONENT THE DESKTOP RENDERS, not a phone-shaped retelling of it. The only thing
// this file supplies is chrome — a band with a back control, the top safe area, and one scroll
// region with the tab bar's clearance under it — plus `compact`, which stacks the settings rows and
// unpicks the log's hanging indent. No copy differs, no state is dropped, nothing is hidden: the
// device list, the test button, the four kind switches, the two leads and the log are all here,
// because a phone that showed a subset would be a second, quieter source of truth.
//
// THE ENTRY POINT is the gear in Day's notifications sheet (V10 board 22 → 24; mobile/day/
// NotifSheet.tsx) — Day is the home, the one screen the owner always lands on, and the phone has
// no account or "more" area to put it in. The tab bar has no settings entry either (V10: five tabs
// and the +).
// ============================================================================

export function MobileNotificationsSettings() {
  return (
    <>
      <Band band="today" className="px-[14px] pb-3 pt-[6px]">
        <BackRow label="Today" />
        <BandHeading
          title="Notifications"
          subline={
            <span>Web Push to this phone — what is sent, and what actually arrived</span>
          }
        />
      </Band>

      {/* One scroll region, the page gutter, and the 20px column gap the desktop settings
          screens use between sections — `SettingsScreen` supplies it there, so it is supplied
          here rather than left to the sections to grow their own. */}
      <div
        className="flex min-h-0 flex-1 flex-col gap-[20px] overflow-y-auto overflow-x-hidden px-[14px] pt-[2px]"
        style={{ paddingBottom: SCROLL_BOTTOM }}
      >
        <NotificationsBody compact />
      </div>
    </>
  )
}
